import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

const prop = 'preparerStatusColumn';
export const id = 'preparerAssignmentStatusColumn';

export const config = (labels) =>
	barchartColumnConfig({
		fullId: id,
		label: labels.status,
		prop,
		customHeaderTooltip: utilLabels.basedOnPreparerAssignments,
		getSeries: (item) => [
			{
				name: utilLabels.closed,
				data: [item.pACompld],
				color: dashboardChartColors.blue[3]
			},
			{
				name: utilLabels.inprogress,
				data: [item.pAInProg],
				color: dashboardChartColors.blue[2]
			},
			{
				name: utilLabels.open,
				data: [item.pAOpen],
				color: dashboardChartColors.blue[0]
			}
		]
	});
